module.exports = {
  "country": "RO",
  "artist": "Mihai Traistríu",
  "song": "Tornero",
  "year": "2006",
  "place": "4",
  "spotify": "1dzPd26fs0bfJL6lXjRPvf"
};